import React from "react";
import styles from "./CartItem.module.css";
import "../../fonts/Futura-PT-Book.ttf";
import CartProduct from "./CartProduct";
import { data } from "./CartDemoData";
const CartBox = () => {
  return (
    <div>
      {data && (
        <div className={` ${styles.cartbox}`}>
          {data.map((data, i) => (
            <CartProduct data={data} />
          ))}

          <h6 className={styles.total}>
            商品合計 <span className={styles.amount}>¥46,200</span>
          </h6>
          <h6 className={styles.offer}>あと〇〇円で送料無料</h6>
        </div>
      )}
    </div>
  );
};

export default CartBox;
